module.exports = __webpack_public_path__ + "media/large_wide_echo_hall.8eacb0f1.wav";